document.addEventListener('DOMContentLoaded',function(){
  var nav=document.querySelector('.nav');
  var toggle=document.querySelector('.nav-toggle');
  if(toggle&&nav){
    var links=nav.querySelector('.nav-links');
    var openLabel=toggle.getAttribute('aria-label')||'Open menu';
    if(links&&!links.id){links.id='primary-nav';}
    toggle.setAttribute('aria-expanded','false');
    if(links){toggle.setAttribute('aria-controls',links.id);}
    function setOpen(open){
      nav.classList.toggle('open',open);
      document.body.classList.toggle('menu-open',open);
      toggle.setAttribute('aria-expanded',open?'true':'false');
      toggle.setAttribute('aria-label',open?'Close menu':openLabel);
      toggle.textContent=open?'×':'☰';
    }
    toggle.addEventListener('click',function(){setOpen(!nav.classList.contains('open'));});
    if(links){[].forEach.call(links.querySelectorAll('a'),function(a){a.addEventListener('click',function(){setOpen(false);});});}
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape'&&nav.classList.contains('open')){setOpen(false);toggle.focus();}
    });
    window.addEventListener('resize',function(){if(window.innerWidth>900&&nav.classList.contains('open')){setOpen(false);}});
  }
});
